import React from 'react';
import { FaEdit } from 'react-icons/fa';
import * as Yup from 'yup';

import { IColor } from '../../../../../../models';

import {
  ColorItem,
  ColorsList,
  Container,
  Header,
  EditColorsButton,
} from './styles';

type ColorsProps = {
  colors: IColor[];
};

export const ColorsFormSchema = Yup.object().shape({});

const Colors: React.FC<ColorsProps> = ({ colors }) => {
  return (
    <Container>
      <Header>
        <h2>Cores</h2>
        <p>
          Veja aqui quais as cores que seus produtos poderão ter, você pode
          editá-las acessando as configurações da loja
        </p>
      </Header>
      <ColorsList>
        {colors.map((color) => (
          <ColorItem key={color.id} color={color.hex}>
            <h3>{color.name}</h3>
            <div />
          </ColorItem>
        ))}
      </ColorsList>
      <EditColorsButton to="/configuracoes/7/0">
        <FaEdit /> Editar cores
      </EditColorsButton>
    </Container>
  );
};

export default Colors;
